import { __extends } from 'tslib';
import * as React from 'react';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkScrim, UitkScrimType } from 'uitk-react-scrim';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-media-gallery.css';

var getClassNameList = classNames.bind(styles);
var UitkMediaGalleryImageFooter = /** @class */ (function (_super) {
    __extends(UitkMediaGalleryImageFooter, _super);
    function UitkMediaGalleryImageFooter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkMediaGalleryImageFooter.prototype.render = function () {
        var _a = this.props, imgCaption = _a.imgCaption, className = _a.className, currentIndex = _a.currentIndex, imagesLength = _a.imagesLength;
        var baseClassName = getClassNameList('uitk-media-gallery-image-footer', className);
        var currentIndexDisplay = currentIndex + 1;
        return (React.createElement(UitkScrim, { type: UitkScrimType.BOTTOM },
            React.createElement(UitkLayoutFlex, { className: baseClassName, justifyContent: "space-between", alignItems: "end" },
                React.createElement("span", { className: getClassNameList('uitk-type-300', 'truncate-lines-2') }, imgCaption && imgCaption !== '' && "".concat(imgCaption)),
                imagesLength && imagesLength > 1 && (React.createElement(UitkLayoutFlexItem, { className: getClassNameList('uitk-type-300'), shrink: 0 },
                    React.createElement("span", { "data-stid": "media-gallery-image-counter" }, "".concat(currentIndexDisplay, " / ").concat(imagesLength)))))));
    };
    UitkMediaGalleryImageFooter.displayName = 'UitkMediaGalleryImageFooter';
    return UitkMediaGalleryImageFooter;
}(React.PureComponent));

export { UitkMediaGalleryImageFooter };
